import React from "react";
import AppPage from "../../../../components/CustomUI/AppPage";
import { ToastContainer, Toast } from "../../../../components/CustomUI/Toast";
import ReportViewOptionsPanel from "../shared/ReportViewOptionsPanel";
import "../Reports.scss";

const ProductionReportShell = ({
  title,
  filters,
  machines,
  shifts,
  onApply,
  toasts,
  dismissToast,
  children,
  columns,
  visibleColumns,
  onToggleColumn,
  onResetColumns,
  columnSections,
}) => (
  <AppPage
    title={title}
    actions={
      <ReportViewOptionsPanel
        filters={filters}
        machines={machines}
        shifts={shifts}
        onApply={onApply}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={onToggleColumn}
        onResetColumns={onResetColumns}
        columnSections={columnSections}
      />
    }
  >
    <ToastContainer>
      {toasts.map((t) => (
        <Toast
          key={t.id}
          title={t.message}
          appearance={t.type === "danger" ? "danger" : "success"}
          onClose={() => dismissToast(t.id)}
        />
      ))}
    </ToastContainer>
    {children}
  </AppPage>
);

export default ProductionReportShell;
